module.exports = __webpack_public_path__ + "img/content4.d26e3ff8.png";